import Icon from '@react/Atoms/Icon'

import { ItemType } from '../../../FilterableList/FilterableListTypes'
import { SimpleEvent } from './SimpleEvent'

type SimpleEventsPropsType = {
  eventsPageLink?: string
  eventsPageLinkLabel?: string
  items: ItemType[]
  listTitle?: string
  seoHeadingElement?: string
}

export const SimpleEvents = ({ items, listTitle, seoHeadingElement = 'h2' }: SimpleEventsPropsType) => {
  const HeadingTag = seoHeadingElement as keyof JSX.IntrinsicElements

  if (!items) {
    return
  }

  return (
    <>
      {listTitle && (
        <div className="cmp-filterable-list__heading">
          <HeadingTag className="cmp-filterable-list__heading-title h2">
            <Icon iconName={'calendar'} />
            {listTitle}
          </HeadingTag>
        </div>
      )}
      {items.length > 0 && (
        <div className="cmp-filterable-list__items">
          {items.map((item, index) => (
            <SimpleEvent key={`${index}-${item.title}`} item={item} />
          ))}
        </div>
      )}
    </>
  )
}
